// ----------------------------------------------------------------------------
// Snippet: Modal
// ----------------------------------------------------------------------------
//
// Modal poopup
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
var _bind = require('lodash.bind');


// Styles
import './_modal.scss';


// -------------------------------------
// Variables
// -------------------------------------

// Constant trigger classes
var modal        = '.modal';
var modalOpen    = '.modal--open';
var modalOverlay = '.modal__overlay';
var closeButton  = '.modal__close-button';
var openButton   = '.modal__trigger';

var MODAL = {

    /**
     * [eventOpenModal - Opens up the modal, locks body from scrolling, and adds overlay]
     * @param {Event} e
     * @return void
     */
    open: function($modal) {
        // Open the Modal
        $modal.addClass('modal--open');
        $('body').addClass('noscroll');

        // Enable focus when opening modal
        $modal.find('[tabindex="-1"]').each(function(){
            $(this).attr('tabindex', 0);
        });

        // Broadcast a notification that a modal opened
        $(window).trigger('open.modal', $modal);
    },

    /**
     * [eventCloseModal - Closes up the modal, un-position:fix's body, and removes overlay]
     * @param {Event} e
     * @return void
     */
    close: function() {
        // Determine which modal(s) are open
        var $openModals = $(modalOpen);

        // Close all modals
        $openModals.removeClass('modal--open');
        $('body').removeClass('noscroll');

        // Broadcast a notification that a modal closed
        $.each($openModals, function(index, openModal) {

            // Disable focus for modal content on close
            $(this).find('[tabindex="0"]').each(function(){
                $(this).attr('tabindex', -1);
            });

            $(window).trigger('close.modal', openModal);
        });
    },


    /**
     * [eventOpenModal - Opens up the modal, locks body from scrolling, and adds overlay]
     * @param {Event} e
     * @return void
     */
    clickTrigger: function(event) {
        // Get the modal associated with the target
        var $modal = $('#modal_' + $(event.currentTarget).data('modal-target'));

        // ----------------------------------
        // Trap Focus inside Modal
        // ----------------------------------

        // add all the elements inside modal which you want to make focusable
        const focusableElements     = '[tabindex]:not([tabindex="-1"]), [href], button, input, iframe';
        const modal                 = document.querySelector('#modal_' + $(event.currentTarget).data('modal-target')); // select the modal by it's id
        const firstFocusableElement = $modal.find(focusableElements).first(); // get first element to be focused inside modal
        const focusableContent      = $modal.find(focusableElements);
        const lastFocusableElement  = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

        document.addEventListener('keydown', function(e) {
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination

                if (document.activeElement === firstFocusableElement) {

                    lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }
            } else { // if tab key is pressed

                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab

                    firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
            }
        });

        this.open($modal);
    }
};


/**
 * Bind Modal Triggers
 */
$(document).ready(function() {
    $(document).on('click', openButton,   _bind(MODAL.clickTrigger, MODAL));
    $(document).on('click', closeButton,  _bind(MODAL.close));
    $(document).on('click', modalOverlay, _bind(MODAL.close));
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' || e.keyCode === 27) { // Esc key
            MODAL.close();
        }
    });

    // Open modal on keypress
    $(document).on('keypress', openButton, function(e) {
        if (e.key === 'Enter' || e.keyCode == 13) {
            MODAL.clickTrigger(e);
        }
    });

    // Close modal on keypress
    $(document).on('keypress', closeButton, function(e) {
        if (e.key === 'Enter' || e.keyCode == 13) {
            MODAL.close();
        }
    });

    //----------------------------------
    // Extra code for triggering success modal when contact_posted = true
    // Tied to request-quote.liquid snippet
    //----------------------------------

    // check the current page to see if the #contact-for-quote element exists
    const contactForQuote = document.getElementById('contact-for-quote');

    if (contactForQuote) {
        // Check the current URL to see if the parameter contact_posted is true
        const urlParams = new URLSearchParams(window.location.search);
        const contact_posted = urlParams.get('contact_posted');

        if (contact_posted === 'true') {
            // Open the modal associated with the #contact-for-quote element
            MODAL.open($('#modal_contact-for-quote-modal'));

        }
    }
})

// When a video modal is opened, play the video
$(window).on('open.modal', function(event, modal) {
    $(modal).find('.video-block').trigger('play.video-block');
});


// When a video modal is closed, pause the video
$(window).on('close.modal', function(event, modal) {
    $(modal).find('.video-block').trigger('pause.video-block');
});
